export const namespace = 'products';

export const MutationTypes = {
  SET_PRODUCTS: 'SET_PRODUCTS',
  SET_PRODUCTS_TOTAL_COUNT: 'SET_PRODUCTS_TOTAL_COUNT',
};

export const ActionTypes = {
  GET_PRODUCTS: 'GET_PRODUCTS',
};
